import type { UserBody } from '@/shared/api/generated/model';

/**
 * Текущий сеанс: токен доступа и тот, кто вошёл.
 *
 * Токен лежит в обычной переменной модуля — не в localStorage и не в
 * sessionStorage. Это не забывчивость: посторонний скрипт, попавший на
 * страницу, читает хранилище браузера целиком, а переменную внутри модуля —
 * нет, и умирает она вместе со вкладкой.
 *
 * Сеанс от этого не теряется при перезагрузке: восстановить его можно из
 * cookie с токеном обновления, до которой JavaScript вообще не дотягивается.
 * Поэтому приложение при запуске делает ровно один запрос на обновление.
 */

export type SessionState =
  | { status: 'unknown' }
  | { status: 'anonymous' }
  | {
      status: 'authenticated';
      user: UserBody;
      /**
       * Под учётной записью работает поддержка, а не её владелец.
       *
       * Интерфейс обязан показать это явно и постоянно: человек, забывший,
       * что смотрит на чужие данные, рано или поздно решит, что это его.
       */
      impersonated: boolean;
    };

let accessToken: string | null = null;
let state: SessionState = { status: 'unknown' };

const listeners = new Set<() => void>();

function emit(): void {
  for (const listener of listeners) {
    listener();
  }
}

export function subscribeSession(listener: () => void): () => void {
  listeners.add(listener);

  return () => {
    listeners.delete(listener);
  };
}

export function getSession(): SessionState {
  return state;
}

/** Токен для заголовка Authorization. Читает только `facetaFetch`. */
export function getAccessToken(): string | null {
  return accessToken;
}

export function setSession(token: string, user: UserBody, impersonated = false): void {
  accessToken = token;
  state = { status: 'authenticated', user, impersonated };
  emit();
}

export function clearSession(): void {
  accessToken = null;
  state = { status: 'anonymous' };
  emit();
}
